import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href
}: CTAButtonProps) {
  const baseClasses = 'bg-[#10b981] hover:bg-[#059669] text-white font-bold py-4 px-6 rounded-lg shadow-lg transform transition-all hover:scale-105 text-xl md:text-2xl text-center w-full md:w-auto inline-block cursor-pointer border-b-4 border-[#047857] active:border-b-0 active:translate-y-1';
  if (href) {
    return <a href={href} className={`${baseClasses} ${className}`} data-id="element-14">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={`${baseClasses} ${className}`} data-id="element-15">
      {children}
    </button>;
}